<div
    [id]="id + '.' + filter.id"
    class="agpr-filterCheckboxes"
    [ngClass]="{'social': style === agprComponentStyle.social}"
>
    <agpr-filter-include-exclude
        *ngIf="filter.showIncludeExclude"
        [(ngModel)]="filter.currentIncludeExclude"
        (ngModelChange)="currentIncludeExcludeChange()"
    ></agpr-filter-include-exclude>
    <label
        *ngIf="filter.showSearch"
        class="agpr-filterCheckboxes-search"
    >
        <agpr-text-input
            [id]="id + '.' + filter.id + '.search'"
            icon="fa-regular fa-duotone fa-magnifying-glass"
            [(ngModel)]="searchQuery"
            (ngModelChange)="search()"
            [placeholder]="filter.placeholder"
            [style]="style"
            (keydown)="handleInputKeydown($event)"
            ariaLabel="Monitoring.autoTaggingTopicFilterSearch"
        ></agpr-text-input>
    </label>
    <div
        *ngIf="filteredOptions.length > 0 || showAddCustomButton"
        class="agpr-filterCheckboxes-toggleContainer"
    >
        @if (filter.showFilterLabel) {
            <div class="agpr-filterCheckboxes-filterLabel">
                {{ filter.label | localize }}
            </div>
        }
        <agpr-button
            [id]="id + '.' + filter.id + (anyOptionsSelected ? '.selectNone' : '.selectAll')"
            class="agpr-filterCheckboxes-allToggle"
            (click)="selectItems()"
            aria-live="polite"
            [style]="buttonTypes.link"
            [label]="(anyOptionsSelected ? 'selectNone' : 'selectAll') | localize"
        ></agpr-button>
        @if (showAddCustomButton) {
            <agpr-button
                [id]="id + '.' + filter.id + '.addCustom'"
                label="Common.filter.checkboxes.addCustom"
                [style]="buttonTypes.tertiary"
                (click)="addCustom()"
            ></agpr-button>
        }
    </div>
    <agpr-scroll-panel #scrollPanel>
        <div class="agpr-filterCheckboxes-noContent" *ngIf="filteredOptions.length < 1">
            <agpr-message
                class="agpr-leftSidebar-noItemsMessage"
                [severity]="severity.noContent"
            >{{ 'Common.filter.noContent' | localize }}
            </agpr-message>
        </div>
        <ul
            class="agpr-filterCheckboxes-list"
            [attr.aria-label]="'filter' | localize"
        >
            <li
                *ngFor="let option of filteredOptions; let i = index"
                class="agpr-filterCheckboxes-item"
            >
                <agpr-checkbox
                    [id]="id + '_' + filter.id + '_checkbox-' + i"
                    class="agpr-filterCheckboxes-checkbox"
                    [name]="'filterCheckboxes-' + filter.id"
                    [(ngModel)]="value"
                    [value]="option.value"
                    [label]="option.label"
                    (ngModelChange)="handleChange()"
                >
                    <span
                        *ngIf="option.count || option.count === 0"
                        class="agpr-filterCheckboxes-itemCount"
                        [pTooltip]="option.count | number"
                    >
                        {{ option.count | significantDigits : 1}}
                    </span>
                </agpr-checkbox>
            </li>
        </ul>
    </agpr-scroll-panel>
</div>
